import {useEffect, useState} from 'react';
import {useSearchParams} from 'react-router-dom';
import {Container, Row} from 'react-bootstrap';
import HeaderTFAF from './HeaderTFAF';
import FooterTFAF from './FooterTFAF';
import NavigateMBI from './NavigateMBI';
import NavigateAAMBI from './NavigateAAMBI';
import '@datadog/browser-logs/bundle/datadog-logs';
import {PARTNER_CONFIG} from '../partner-configs/partnerConfig';
import {detectSource} from '../utils/sourceDetection';

window.DD_LOGS.init({
  clientToken: 'pub460001996571a504399d6864b9d593bc',
  site: 'datadoghq.com',
  forwardErrorsToLogs: true,
  sessionSampleRate: 100,
});

const PaymentSuccess = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [isSuccess, setIsSuccess] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isProcessing, setIsProcessing] = useState(true);

  const [vehicleData, setVehicleData] = useState({});
  const [quoteData, setQuoteData] = useState({});
  const [, setTodaysDate] = useState();
  const [pageRefreshed, setPageRefreshed] = useState(false);

  const source = detectSource();
  const isAAPath = source === 'AA' || source === 'AA_MEMBER';
  const partner = PARTNER_CONFIG[source];
  const baseUrl = window.location.origin;

  const steps = [
    { name: 'Step 1', status: 'complete', desc: 'Car details' },
    {
      name: 'Step 2',
      status: 'complete',
      desc: 'Choose your cover',
    },
    { name: 'Step 3', status: 'complete', desc: 'About you' },
    {
      name: 'Step 4',
      status: partner.status ?? 'complete',
      desc: 'Pay now',
    },
  ];

  const handleNewQuoteClick = () => {
    const url = `/mbi?step=1&utm_medium=last&utm_source=conmbi&utm_campaign=${partner.campaign}&utm_content=t`;
    window.location.href = url;
  };

  const handleNewCarQuoteClick = () => {
    const href = window.location.href.toLowerCase();
    let env = 'prod';
    if (href.includes('dev') || href.includes('localhost')) env = 'dev';
    else if (href.includes('uat')) env = 'uat';
    else if (href.includes('int')) env = 'int';
    else if (href.includes('pre')) env = 'pre';
    const domain =
      env === 'prod' ? 'car.autosure.co.nz' : `car.${env}.autosure.co.nz`;
    window.location.href = `https://${domain}/vehicle?utm_medium=last&utm_source=conmbi&utm_campaign=${partner.campaign}&utm_content=t`;
  };

  useEffect(() => {
    window.DD_LOGS.logger.info('Start useeffect in payment success');
    let env = '';
    if (window.location.href.includes('dev')) {
      env = 'dev: ';
    } else if (window.location.href.includes('uat')) {
      env = 'uat: ';
    } else if (window.location.href.includes('int')) {
      env = 'int: ';
    } else if (window.location.href.includes('pre')) {
      env = 'pre: ';
    } else if (window.location.href.includes('localhost')) {
      env = 'localhost: ';
    } else {
      env = 'prod: ';
    }
    let url = window.location.href.includes('localhost')
      ? 'http://localhost:8080/edge'
      : '/edge';
    window.DD_LOGS.logger.info(env + 'inside useeffect set env');
    var today = new Date();
    setTodaysDate(
      String(today.getDate()).padStart(2, '0') +
        ' ' +
        today.toLocaleString('en-us', { month: 'short' }) +
        ' ' +
        today.getFullYear(),
    );
    window.DD_LOGS.logger.info(env + 'Get all the params');
    let renewalId = searchParams.get('id');
    env = env + renewalId + ' :';
    window.DD_LOGS.logger.info(env + 'Param values ');
    window.DD_LOGS.logger.info(
      env + `${url}/prospect/complete?renewalId=${renewalId}`,
    );
    fetch(`${url}/prospect/complete?renewalId=${renewalId}`, {
      method: 'GET',
      mode: 'cors',
      headers: new Headers({
        Accept: 'application/json',
        Authorization: 'By-Pass-Auth-Create-Prospect',
      }),
    })
      .then((response) => {
        response.json().then((json) => {
          if (json.vehicle === undefined) {
            setPageRefreshed(true);
            return;
          }
          setVehicleData(json.vehicle);
          // console.log(json.quote);
          setQuoteData(json.quote);

          if (partner.purchaseEvent) {
            partner.purchaseEvent(json);
          }
        });
        if (response.ok) {
          if (!window.location.hostname.includes('aa')) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'mbiAutosureEvent',
              category: 'Payment',
              status: 'Success',
              paymentMethod: 'Card',
              cardType: 'Unknown',
            });
          }
          if (isAAPath) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              'event': 'virtualPageview',
              'virtualUrl': '/aa/paymentsuccess',
              'pageTitle': 'Payment Success'
            });
          }
          setIsProcessing(false);
          setIsSuccess(true);
        } else {
          setIsProcessing(false);
          setIsError(true);
        }
      })
      .catch((err) => {
        setIsProcessing(false);
        setIsError(true);
        console.error('Caught error: ', err);
      });
    window.DD_LOGS.logger.info(env + 'gtag start');
    if (window.gtag && partner.useGtag) {
      window.gtag('event', 'Page visited', {
        event_category: 'Page',
        event_label: 'Payment success page',
      });
    }
    window.DD_LOGS.logger.info(env + 'gtag added');
    searchParams.delete('userid');
    setSearchParams(searchParams);
  }, []);

  return (
    <>
      {isProcessing && (
        <div>
          <br />
          {isProcessing && (
            <>
              {' '}
              <br />
              <br />
              <p className="text-font-label">
                Please wait while we are processing your request.....
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
              </p>
            </>
          )}
        </div>
      )}

      <>
        <HeaderTFAF />
        <Container>
          {isError && (
            <>
              {' '}
              <br />
              <br />
              <p className="text-font-label">
                Sorry there was an unforeseen error.{' '}
              </p>
              <p className="text-font-label">
                We will resolve this and send you the policy documents as soon
                as possible.{' '}
              </p>
              <p className="text-font-label">
                In the meantime if you want to get in touch with us contact us
                on{' '}
                <span
                  className="spanLink"
                  onClick={() => {
                    partner.isCustomer
                      ? (window.location = 'tel:0800262411')
                      : (window.location = 'tel:0800267873');
                  }}
                >
                  {partner.isCustomer ? '0800 262 411' : '0800 267 873'}
                </span>{' '}
                or{' '}
                <a href="mailto:insurance@autosure.co.nz">
                  insurance@autosure.co.nz
                </a>{' '}
                with your car registration and we'll be happy to help.{' '}
              </p>
              <p className="text-font-label">Thanks</p>
              <p className="bold-text">
                <h5 style={{ fontWeight: 'bold' }}>The MBI Team</h5>
              </p>
              <br />
              <br />
              <br />
              <br />
            </>
          )}
          {isSuccess && (
            <>
              <br />
              <Row className="justify-content-center">
                {source === 'AA' || source === 'AA_MEMBER' ? (
                  <>
                    <br />
                    <NavigateAAMBI steps={steps} />
                  </>
                ) : (
                  <NavigateMBI steps={steps} />
                )}
              </Row>
              <br />
              <br />
              <p className="subHeadingStyles">
                Thanks for choosing {partner.displayName} Mechanical Breakdown
                Insurance
              </p>
              <p className="regularTextStyles">
                We’re pleased to confirm your payment was successful.&nbsp; Your
                policy is now in place and you can rest assured that you'll be
                in safe hands if your car breaks down.
                {pageRefreshed && (
                  <>
                    The page has been refreshed. We'll email your insurance
                    documents to you within the next 24 hours.
                  </>
                )}
              </p>

              {!pageRefreshed && (
                <>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      width: '330px',
                      boxShadow: '-1px 1px 5px 6px rgba(0,0,0,0.06)',
                    }}
                  >
                    <div
                      className="table-header"
                      style={{
                        textAlign: 'start',
                        paddingLeft: '24px',
                        paddingTop: '16px',
                        width: '100%',
                      }}
                    >
                      <p
                        className="subHeadingWhiteTextStyles"
                        style={{ fontSize: '20px' }}
                      >
                        {' '}
                        Policy details
                      </p>
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        height: '50px',
                      }}
                    >
                      <div
                        id="policyNumberTitle"
                        style={{
                          background: 'white',
                          textAlign: 'start',
                          paddingLeft: '24px',
                          width: '100%',
                          color: partner.color ?? '#1851a3',
                        }}
                      >
                        Policy number
                      </div>
                      <div
                        id="policyNumberVal"
                        style={{
                          color: 'black',
                          textAlign: 'start',
                          paddingLeft: '24px',
                          width: '100%',
                        }}
                      >
                        <span className="boldTextStyles">
                          {quoteData.policyNumber &&
                          quoteData.policyNumber.trim() !== ''
                            ? quoteData.policyNumber
                            : quoteData.id}{' '}
                        </span>
                      </div>
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        background: '#F3F4F6',
                        alignItems: 'center',
                        height: '50px',
                      }}
                    >
                      <div
                        id="carRegText"
                        style={{
                          color: partner.color ?? '#1851a3',
                          textAlign: 'start',
                          paddingLeft: '24px',
                          width: '100%',
                        }}
                      >
                        Car registration
                      </div>
                      <div
                        id="carRegVal"
                        style={{
                          color: 'black',
                          textAlign: 'start',
                          paddingLeft: '24px',
                          width: '100%',
                        }}
                      >
                        <span className="boldTextStyles">
                          {vehicleData.registration}{' '}
                        </span>
                      </div>
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        height: '50px',
                      }}
                    >
                      <div
                        id="coverTypeTitle"
                        style={{
                          textAlign: 'start',
                          paddingLeft: '24px',
                          width: '100%',
                          color: partner.color ?? '#1851a3',
                        }}
                      >
                        Cover type
                      </div>
                      <div
                        id="coverTypeVal"
                        style={{
                          color: 'black',
                          textAlign: 'start',
                          paddingLeft: '24px',
                          width: '100%',
                        }}
                      >
                        <span className="boldTextStyles">
                          {quoteData.cover}
                        </span>
                      </div>
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-around',
                        background: '#F3F4F6',
                        alignItems: 'center',
                        height: '50px',
                      }}
                    >
                      <div
                        id="termText"
                        style={{
                          textAlign: 'start',
                          paddingLeft: '24px',
                          width: '100%',
                          color: partner.color ?? '#1851a3',
                        }}
                      >
                        Term
                      </div>
                      <div
                        id="termVal"
                        style={{
                          color: 'black',
                          textAlign: 'start',
                          paddingLeft: '24px',
                          width: '100%',
                        }}
                      >
                        <span className="boldTextStyles">
                          {' '}
                          {quoteData.term / 12}{' '}
                          {quoteData.term / 12 === 1 ? 'year' : 'years'}
                        </span>
                      </div>
                    </div>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-around',
                        alignItems: 'center',
                        height: '50px',
                      }}
                    >
                      <div
                        id="startDateTitle"
                        style={{
                          textAlign: 'start',
                          paddingLeft: '24px',
                          width: '100%',
                          color: partner.color ?? '#1851a3',
                        }}
                      >
                        Start date
                      </div>
                      <div
                        id="startDateVal"
                        style={{
                          color: 'black',
                          textAlign: 'start',
                          paddingLeft: '24px',
                          width: '100%',
                        }}
                      >
                        <span className="boldTextStyles">
                          {' '}
                          {new Date(Date.now()).toLocaleDateString('en-GB', {
                            day: 'numeric',
                            month: 'long',
                            year: 'numeric',
                          })}
                        </span>
                      </div>
                    </div>
                  </div>
                  <br />
                  <p className="subHeadingStyles secondaryFont">What's next</p>
                  <p className="regularTextStyles">
                    Your insurance documents will be emailed to you within the
                    next 24 hours. Please review these to ensure the cover meets
                    your requirements.
                  </p>

                  <p className="regularTextStyles">
                    This email will come from{' '}
                    <a
                      style={{ color: 'black' }}
                      href="mailto:support@ops.autosure.co.nz"
                    >
                      support@ops.autosure.co.nz
                    </a>{' '}
                    as Autosure Insurance Limited is the underwriter of your
                    policy and ‘Autosure’ will appear as the payee on your bank
                    statement.
                  </p>
                  <p className="regularTextStyles">
                    You can cancel your policy within{' '}
                    {quoteData?.policyNumber ? '30' : '15'} days of the start of
                    your cover, provided you have not made a claim and we will
                    refund you any premiums you have paid.
                  </p>

                  <p className="regularTextStyles">
                    With this protection in place, we hope you enjoy many years
                    of peace of mind driving ahead.
                  </p>
                </>
              )}
              <br />
              <p className="boldTextStyles">What would you like to do now?</p>
              <ul style={{ paddingBottom: '150px' }}>
                <li style={{ paddingBottom: '5px' }}>
                  <span
                    style={{
                      color: partner.color ?? '#0073CF',
                      textDecoration: 'underline',
                      cursor: 'pointer',
                      fontSize: '14px',
                    }}
                    onClick={handleNewQuoteClick}
                  >
                    + Get another quote
                  </span>
                </li>
                {partner.showCarInsurance && (
                  <>
                    <li style={{ paddingBottom: '5px' }}>
                      <span
                        style={{
                          color: '#0073CF',
                          textDecoration: 'underline',
                          cursor: 'pointer',
                          fontSize: '14px',
                        }}
                        onClick={handleNewCarQuoteClick}
                      >
                        + Get a quote for Car Insurance
                      </span>
                    </li>
                  </>
                )}
                <li style={{ fontSize: '14px' }}>
                  Nothing I’m all sorted thanks
                </li>
              </ul>
            </>
          )}
        </Container>
        <FooterTFAF />
      </>
    </>
  );
};

export default PaymentSuccess;
